import cookies from 'js-cookie';

export function isAuthenticated() {
  const token = cookies.get('app_token');

  return token?.length > 0;
}
